import { SearchResult } from '../../types'
import { DataTable } from '../../ui'
import CursorPagination from '../../ui/Pagination'
import { SearchRecord, SearchTableProps } from './TableTypes'

export const CursorTable = <T extends SearchRecord>({ results, columnSort, params, setParams, ...rest }: SearchTableProps<T> & { results: SearchResult<T> | null }) => {
    return <>
        <DataTable {...rest}
            items={results?.results}
            isLoading={!results}
            columnSort={columnSort}
            onColumnSort={(onSort) => {
                const { sort, direction, ...prevParams } = params
                setParams({ ...prevParams, ...onSort })
            }} />
        {results && (
            <div>
                <CursorPagination
                    nextCursor={results.nextCursor}
                    prevCursor={results.prevCursor}
                    onPrev={cursor => setParams({ ...params, cursor, cursor_direction: 'prev' })}
                    onNext={cursor => setParams({ ...params, cursor, cursor_direction: 'next' })} />
            </div>
        )}
    </>
}
